import { render, staticRenderFns } from "./KeywordsView.vue?vue&type=template&id=a68ce4de"
import script from "./KeywordsView.vue?vue&type=script&lang=js"
export * from "./KeywordsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports